<template>
  <v-row>
    <v-col>
      <v-card class="elevation-0">
        <v-card-text>
          <div class="mt-n3 mb-3">
            <v-btn small text exact :to="{name: 'food-search'}"><v-icon small class="mr-2">mdi-arrow-left</v-icon>Back To Food Search</v-btn>
          </div>
          <requests-browser />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import RequestsBrowser from './components/FoodRequestsBrowser'

export default {
  name: 'FoodSearchRequestsIndex',
  components: {
    'requests-browser': RequestsBrowser
  },
  data: () => ({
  }),
  methods: {
    
  }
};
</script>